import type {CreateControllerFn} from '@wix/yoshi-flow-editor';

export const conditionalController =
  (
    experimentName: string,
    controllerWhenTrue: CreateControllerFn,
    controllerWhenFalse: CreateControllerFn
  ): CreateControllerFn =>
  (controllerParams) => {
    const siteStore = controllerParams.appData?.context?.siteStore;

    if (!siteStore?.experiments.enabled(experimentName)) {
      return controllerWhenFalse(controllerParams);
    }

    return controllerWhenTrue(controllerParams);
  };
